<div *ngIf="this.access" class="container-fluid p-0">
  <div class="col-12">
    <!-- Stats -->
    <div class="row">
      <!-- Orders -->
      <div class="col-md-4">
        <div class="mini-card mini-stats-wid mb-4">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <div class="flex-1">
                <p class="text-muted fw-600 f-14">{{ "Orders" | translate | async }}</p>
                <h4 class="mb-0 f-14">{{ cardsData.orders | number }}</h4>
              </div>
              <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                <span class="avatar-title">
                  <i class="bx bx-copy-alt font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Revenue -->
      <div class="col-md-4">
        <div class="mini-card mini-stats-wid mb-4">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <div class="flex-1">
                <p class="text-muted fw-600 f-14">{{ "Revenue" | translate | async }}</p>
                <h4 class="mb-0 f-14">{{ currency }}{{ cardsData.products | number : ".2-2" }}</h4>
              </div>
              <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                <span class="avatar-title">
                  <i class="bx bx-archive-in font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Total Merchants -->
      <div class="col-md-4">
        <div class="mini-card mini-stats-wid mb-4">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <div class="flex-1">
                <p class="text-muted fw-600 f-14">{{ "Total Merchants" | translate | async }}</p>
                <h4 class="mb-0 f-14">{{ cardsData.merchants | number }}</h4>
              </div>
              <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                <span class="avatar-title">
                  <i class="bx bx-purchase-tag-alt font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Revenue -->
    <div class="card">
      <div class="card-body net-sales-RTL">
        <div class="row justify-content-between align-baseline net-sales-details-RTL">
          <div class="col-md-10 d-sm-flex flex-wrap justify-content-between align-items-center">
            <h5 class="card-title fw-600 mb-4 font-size-20 pd-left10">{{"eatOS Commission" | translate | async}}</h5>

          </div>
          <!-- Date Picker -->
          <div class="col-md-2 w-fit p-0">
            <div class="input-group mb-3">
              <div ngbDropdown class="input-group-text p-0 border-color-input">
                <button
                  class="btn datepicker-btn"
                  id="periodDropDown"
                  ngbDropdownToggle
                >
                  {{ selectDateoption | translate | async }} <i class="mdi mdi-menu-up up"></i
                  ><i class="mdi mdi-menu-down down"></i>
                </button>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownBasic1"
                  class="fw-500 f-12"
                >
                  <ng-container *ngFor="let type of dateFilteroptions">
                    <button
                      ngbDropdownItem
                      [ngClass]="selectDateoption === type ? 'disabled' : ''"
                      [disabled]="selectDateoption === type"
                      (click)="selectedDateOption(type)"
                    >
                      {{ type | translate | async }}
                    </button>
                  </ng-container>
                </div>
              </div>
              <div
                class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
              >
                <div class="datepickerwrap form-control" (click)="picker.open()">
                  <span class="date-text ms-2">
                    <span class="display-date">{{
                      startDateDisplayFormatted | translate | async
                    }}</span>
                    -
                    <span class="display-date">{{ endDateDisplayFormatted| translate | async }}</span>
                  </span>
                  <img
                    src="../../../../assets/images/dashboard-images/bx-calendar.png"
                    class="ms-3 picker-icon"
                  />

                  <div class="mat-datepicker-hide">
                    <mat-date-range-input [rangePicker]="picker">
                      <input
                        matStartDate
                        placeholder="Start date"
                        [(ngModel)]="a1"
                      />
                      <input
                        matEndDate
                        placeholder="End date"
                        [(ngModel)]="a2"
                        (ngModelChange)="selectedDate($event)"
                      />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!revenueLoader">
          <apx-chart dir="ltr" class="apex-charts" [chart]="revenueBarChart.chart" [series]="revenueBarChart.series"
            [legend]="revenueBarChart.legend" [colors]="revenueBarChart.colors" [fill]="revenueBarChart.fill"
            [dataLabels]="revenueBarChart.dataLabels" [labels]="revenueBarChart.labels" [yaxis]="revenueBarChart.yaxis"
            [plotOptions]="revenueBarChart.plotOptions">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="revenueLoader" height="400px">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title fw-600 mb-4 font-size-20 pd-left10">{{ "Alerts" | translate | async }}</h5>
            <ng-container *ngIf="alerts.length > 0">
              <ul class="verti-timeline list-unstyled">
                <li class="event-list" *ngFor="let alert of alerts">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle font-size-18"
                      [ngClass]="{ 'bxs-right-arrow-circle bx-fade-right' : alert?.unread === true }"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <h5 class="font-size-14">{{ convertDate(alert?.createdAt) }} <i
                          class="bx bx-right-arrow-alt font-size-16 text-dark align-middle ms-2"></i>
                      </h5>
                    </div>
                    <div class="media-body">
                      <div class="font-size-14">
                        {{ alert?.alertMessage | translate | async }}
                        <!-- <span *ngIf="alert.link">
                          (<a [href]="alert.link" target="_blank" class="text-primary">{{ alert.link }}</a>)
                        </span> -->
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="text-center mt-4">
                <a href="javascript: void(0);" class="btn btn-dark btn-sm disabled">
                  {{ "View More" | translate | async }} <i class="mdi mdi-arrow-right ms-1"></i>
                </a>
              </div>
            </ng-container>
            <p *ngIf="alerts.length === 0" class="text-center">{{ "No alerts available." | translate | async }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title fw-600 mb-4 font-size-20 pd-left10">{{ "Top Merchants" | translate | async }}</h5>
            <ng-container *ngIf="topMerchants?.length > 0">
              <div class="text-center">
                <div class="mb-4">
                  <i class="bx bx-map-pin text-dark display-4"></i>
                </div>
                <ng-container *ngIf="topMerchant">
                  <h3>{{ currency }}{{ topMerchant.total | number : ".2-2" }}</h3>
                  <p>{{ topMerchant.merchantName }}</p>
                </ng-container>
              </div>
              <div class="table-responsive mt-4">
                <table class="table table-centered table-nowrap">
                  <tbody>
                    <tr *ngFor="let merchant of topMerchants">
                      <td style="width: 30%">
                        <p class="mb-0 font-size-14">{{ merchant.merchantName }}</p>
                      </td>
                      <td style="width: 25%">
                        <h5 class="mb-0 font-size-14">{{ currency }}{{ merchant.total | number : ".2-2" }}</h5>
                      </td>
                      <td>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-dark rounded" role="progressbar"
                            [style.width]="calculateProgress(merchant.total, maxTotal) + '%'"
                            [attr.aria-valuenow]="calculateProgress(merchant.total, maxTotal)" aria-valuemin="0"
                            aria-valuemax="100"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
            <p *ngIf="topMerchants?.length === 0" class="text-center">{{ "No top merchants available." | translate | async }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Latest Transactions -->
    <div class="card">
      <div class="card-body">
        <h5 class="card-title fw-600 mb-4 font-size-20 pd-left10">{{"Latest Transactions" | translate | async}}</h5>
        <div class="table-responsive mb-0">
          <table class="table table-centered table-nowrap latest-transactions-table">
            <thead class="table-light">
              <tr>
                <!-- <th style="width: 20px;">
                  <div class="form-check font-size-16 align-middle">
                    <input class="form-check-input" type="checkbox" id="transactionCheck01">
                    <label class="form-check-label" for="transactionCheck01"></label>
                  </div>
                </th> -->
                <th class="align-middle">{{"Payment ID" | translate | async}}</th>
                <th class="align-middle">{{"Restaurant Name" | translate | async}}</th>
                <th class="align-middle">{{"Location Name" | translate | async}}</th>
                <th class="align-middle">{{"Server Name" | translate | async}}</th>
                <th class="align-middle">{{"Date" | translate | async}}</th>
                <th class="align-middle">{{"Total" | translate | async}}</th>
                <th class="align-middle">{{"Payment Status" | translate | async}}</th>
                <th class="align-middle">{{"Payment Method" | translate | async}}</th>
                <!-- <th class="align-middle">{{"View Details" | translate | async}}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="transactions?.length === 0">
                <td colspan="9" class="text-center">{{"No transactions found" | translate | async}}</td>
              </tr>
              <ng-container *ngFor="let data of transactions
              | paginate
                      : {
                          itemsPerPage: itemsPP,
                          currentPage: p,
                          totalItems: totalElements
                        };
                  let x = index">
                <tr>
                  <!-- <td>
                    <div class="form-check font-size-16">
                      <input class="form-check-input" type="checkbox" id="transactionCheck{{data.index}}">
                      <label class="form-check-label" for="transactionCheck{{data.index}}"></label>
                    </div>
                  </td> -->
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold">{{data?.payId || "N/A"}}</a>
                  </td>
                  <td>{{data.merchant}}</td>
                  <td>{{data.storeName}}</td>
                  <td>{{data.server}}</td>
                  <td>{{convertDate(data.date)}}</td>
                  <td>{{ currency }}{{data.amount | number : ".2-2"}}</td>
                  <td>
                    <span class="badge badge-pill badge-soft-success font-size-11" [ngClass]=" { 'badge-soft-danger': data.status === 'Refunded' || data.status === 'Refund',
                                  'badge-soft-warning':data.status === 'Cancelled' }">{{data.status}}</span>
                  </td>
                  <td>
                    <img *ngIf="data.type == 'Mastercard'" src="../../../assets/images/master.png">
                    <img *ngIf="data.type == 'Visa'" src="../../../assets/images/visa.png">
                    <img *ngIf="data.type == 'Discover'" src="../../../assets/images/discover.png">
                    {{data.type}}
                  </td>
                  <!-- <td>
                    <button type="button" class="btn btn-dark btn-rounded btn-sm" (click)="openModal(content)">{{"View Details" | translate | async}}</button>
                  </td> -->
                </tr>
              </ng-container>

            </tbody>
          </table>

          <!-- Modal -->
          <ng-template #content role="document" let-modal>
            <div class="modal-header">
              <h5 class="modal-title mt-0">{{"Order Details" | translate | async}}</h5>
              <button type="button" class="btn-close" aria-hidden="true"
                (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
              <p class="mb-2">
                {{"Product ID" | translate | async}}:
                <span class="text-primary">#SK2540</span>
              </p>
              <p class="mb-4">
                {{"Billing Name:" | translate | async}}
                <span class="text-primary">Neal Matthews</span>
              </p>
              <div class="table-responsive">
                <table class="table table-centered table-nowrap">
                  <thead>
                    <tr>
                      <th scope="col">{{"Product" | translate | async}}</th>
                      <th scope="col">{{"Product Name" | translate | async}}</th>
                      <th scope="col">{{"Price" | translate | async}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src="assets/images/product/img-7.png" alt class="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 class="text-truncate font-size-14">{{"Wireless Headphone (Black)" | translate | async}}
                          </h5>
                          <p class="text-muted mb-0">$ 225 x 1</p>
                        </div>
                      </td>
                      <td>$ 255</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src="assets/images/product/img-4.png" alt class="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 class="text-truncate font-size-14">{{"Phone patterned cases" | translate | async}}</h5>
                          <p class="text-muted mb-0">$ 145 x 1</p>
                        </div>
                      </td>
                      <td>$ 145</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <h6 class="m-0 text-end">{{"Sub Total:" | translate | async}}</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <h6 class="m-0 text-end">{{"Shipping:" | translate | async}}</h6>
                      </td>
                      <td>{{"Free" | translate | async}}</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <h6 class="m-0 text-end">{{"Total:" | translate | async}}</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" (click)="modal.close('Close click')">{{"Close" | translate |
                async}}</button>
            </div>
          </ng-template>
        </div>
        <!-- PAGINATION -->
        <div class="px-3 d-flex justify-content-between flex-wrap pagination-section pt-2 pb-4">
          <div class="f-14 ts">
              <app-paginate-select [(parameter)]="itemsPP" (update)="onLimitSelected($event)"></app-paginate-select>
          </div>
          <div>
              <pagination-controls class="pagination" (pageChange)="updatePage($event)">
              </pagination-controls>
          </div>
      </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="row" *ngIf="!this.access">
  <div class="col-md-4">
    <div class="card">
      <div class="card-body card-image ">
        <div class="text-center box-height">
          <a href="https://eatos.com" target="blank" class="eatos-help-link">
            <img src="assets/images/eatOS-lg.png" class="mb-3">
            <h5 class="fw-600 font-size-22">
              Go to eatOS.com
            </h5>
          </a>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <div class="text-center box-height">
          <a href="https://support.eatos.com/en-us/" target="blank" class="eatos-help-link">
            <img src="assets/images/instructions.svg" class="mb-3">
            <h5 class="fw-600 font-size-22">
              eatOS Support
            </h5>
            <div class="font-size-14">
              Product Guides, Product Playbooks,
              Manuals
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <div class="text-center box-height">
          <a href="https://support.eatos.com/en-us/category/frequently-asked-questions-1t6dv17/" target="blank"
            class="eatos-help-link">
            <img src="assets/images/faq.svg" class="mb-3">
            <h5 class="fw-600 font-size-22">
              Frequently Asked
              Questions
            </h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</div> -->
